(function () {
  var root = document.querySelector('.ma');
  if (!root) return;

  var form = root.querySelector('.ma-form');
  var vidInput = root.querySelector('.ma-vid');
  var qtyInput = root.querySelector('.ma-qty');
  var qtyBlock = root.querySelector('.ma-qtyblock');
  var nowEl = root.querySelector('.ma-price-now');
  var wasEl = root.querySelector('.ma-price-was');
  var perEl = root.querySelector('.ma-price-per');
  var ctaPriceEl = root.querySelector('.ma-cta-price');
  var sbFmtEl = root.querySelector('.ma-sb-fmt');
  var sbPriceEl = root.querySelector('.ma-sb-price');
  var sticky = root.querySelector('.ma-sticky');
  var sbBtn = root.querySelector('.ma-sb-btn');

  var currency = root.getAttribute('data-currency') || 'INR';
  var fmt;
  try { fmt = new Intl.NumberFormat('en-IN', { style: 'currency', currency: currency, maximumFractionDigits: 0 }); }
  catch (e) { fmt = { format: function (n) { return '₹' + Math.round(n); } }; }

  var firstOpt = root.querySelector('.ma-opt.is-selected') || root.querySelector('.ma-opt');
  var firstQcard = root.querySelector('.ma-qcard.is-selected') || root.querySelector('.ma-qcard');
  var baseQty = firstQcard ? (parseInt(firstQcard.dataset.qty, 10) || 1) : 1;

  var state = {
    basePaise: firstOpt ? (parseInt(firstOpt.dataset.price, 10) || 0) : (parseInt(root.getAttribute('data-base'), 10) || 0),
    multibuy: firstOpt ? firstOpt.dataset.multibuy === 'true' : true,
    qty: baseQty,
    save: firstQcard ? (parseInt(firstQcard.dataset.save, 10) || 0) : 0,
    label: firstOpt ? (firstOpt.dataset.label || '') : ''
  };
  if (firstOpt && vidInput) vidInput.value = firstOpt.dataset.vid || vidInput.value;

  function money(paise) { return fmt.format(Math.round(paise / 100)); }

  function render() {
    if (qtyBlock) qtyBlock.style.display = state.multibuy ? '' : 'none';
    var effQty = state.multibuy ? state.qty : baseQty;
    var save = state.multibuy ? state.save : 0;
    var regular = state.basePaise * effQty;
    var total = Math.round(regular * (1 - save / 100));
    var perBottle = Math.round(total / effQty);

    if (nowEl) nowEl.textContent = money(total);
    if (wasEl) { if (regular > total) { wasEl.textContent = money(regular); wasEl.hidden = false; } else { wasEl.hidden = true; } }
    if (perEl) { if (effQty > 1) { perEl.textContent = money(perBottle) + ' per bottle'; perEl.hidden = false; } else { perEl.hidden = true; } }
    if (ctaPriceEl) ctaPriceEl.textContent = money(total);
    if (sbFmtEl) sbFmtEl.textContent = state.label;
    if (sbPriceEl) sbPriceEl.textContent = money(total);
    if (qtyInput) qtyInput.value = effQty;
  }

  function syncQtyCards() {
    root.querySelectorAll('.ma-qcard').forEach(function (b) {
      b.classList.toggle('is-selected', parseInt(b.dataset.qty, 10) === state.qty);
    });
  }

  root.querySelectorAll('.ma-opt').forEach(function (btn) {
    btn.addEventListener('click', function () {
      root.querySelectorAll('.ma-opt').forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      state.basePaise = parseInt(btn.dataset.price, 10) || 0;
      state.label = btn.dataset.label || '';
      state.multibuy = btn.dataset.multibuy === 'true';
      if (vidInput) vidInput.value = btn.dataset.vid;
      if (!state.multibuy) { state.qty = baseQty; state.save = 0; syncQtyCards(); }
      render();
    });
  });

  root.querySelectorAll('.ma-qcard').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.qty = parseInt(btn.dataset.qty, 10) || baseQty;
      state.save = parseInt(btn.dataset.save, 10) || 0;
      syncQtyCards();
      render();
    });
  });

  (function gallery() {
    var hero = root.querySelector('.ma-hero');
    var heroImg = hero ? hero.querySelector('img') : null;
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.ma-thumbs .ma-thumb'));
    if (!heroImg || !thumbs.length) return;

    var sources = thumbs.map(function (t) {
      var im = t.querySelector('img');
      var src = (im && (im.getAttribute('src') || im.src)) || '';
      return src.replace(/([?&]width=)\d+/, '$11000');
    });
    var current = 0;

    function show(i) {
      current = (i + sources.length) % sources.length;
      heroImg.setAttribute('src', sources[current]);
      heroImg.removeAttribute('srcset');
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-selected', idx === current); });
    }

    thumbs.forEach(function (t, idx) {
      t.addEventListener('click', function () { show(idx); });
    });
    var prev = root.querySelector('.ma-gprev');
    var next = root.querySelector('.ma-gnext');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    if (hero) hero.addEventListener('click', function (e) {
      if (e.target.closest('.ma-gnav')) return;
      show(current + 1);
    });
  })();

  root.querySelectorAll('.ma-faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var a = q.nextElementSibling;
      var open = a && !a.hidden;
      root.querySelectorAll('.ma-faq-a').forEach(function (x) { x.hidden = true; });
      root.querySelectorAll('.ma-faq-i').forEach(function (x) { x.textContent = '+'; });
      if (a && !open) { a.hidden = false; q.querySelector('.ma-faq-i').textContent = '−'; }
    });
  });

  if (sbBtn && form) {
    sbBtn.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
  }

  if (sticky) {
    var clearBottomBars = function () {
      var offset = 0;
      document.querySelectorAll('body *').forEach(function (el) {
        if (el === sticky || sticky.contains(el) || el.contains(sticky)) return;
        var cs = getComputedStyle(el);
        if (cs.position !== 'fixed' || el.offsetHeight === 0 || cs.visibility === 'hidden' || cs.opacity === '0') return;
        var r = el.getBoundingClientRect();
        if (r.width === 0 || r.height === 0) return;
        if (r.bottom >= window.innerHeight - 2) offset = Math.max(offset, Math.round(r.height));
      });
      sticky.style.bottom = offset + 'px';
    };
    var onScroll = function () { sticky.classList.toggle('is-visible', (window.scrollY || 0) > 620); clearBottomBars(); };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', clearBottomBars);
    clearBottomBars();
    setTimeout(clearBottomBars, 1000);
    setTimeout(clearBottomBars, 3000);
    onScroll();
  }

  render();
})();
